// Country-specific data for wizard questions and financial information
export const countryData = {
  germany: {
    name: "Germany",
    code: "germany",
    flag: "🇩🇪",
    services: ["Bachelor's", "Master's", "PhD", "Chancenkarte (Job Seeker)", "Au Pair", "Language Visa", "Ausbildung"],
    questions: [
      {
        id: "al_results",
        type: "radio",
        question: "What are your A/L results?",
        options: ["3 Passes", "2 Passes", "1 Pass", "Still Waiting"]
      },
      {
        id: "ielts_status",
        type: "radio",
        question: "What is your IELTS status?",
        options: ["Have 6.0+", "Taking Soon", "Not Started", "Need Help"]
      }
    ],
    financialTooltip: {
      blockedAccount: "€13,080 per year for living costs (mandatory blocked account)",
      sponsorSavings: "German sponsorship can replace blocked account requirements",
      tuition: "Public universities tuition-free; private options €20,000-30,000/year",
      consulting: "PRO Package: LKR 1,190,000 | Plus Package: LKR 850,000 | DIY: LKR 400,000",
      healthInsurance: "Public health insurance guidance included",
      entryRequirements: "A/L 3 Passes | Bachelor's | IELTS 6.0 | Show Money: LKR 5M minimum"
    }
  },
  canada: {
    name: "Canada",
    code: "canada",
    flag: "🇨🇦",
    services: ["Certificate", "Diploma", "Bachelor's", "PG Diploma", "Master's", "PhD"],
    questions: [
      {
        id: "program_interest",
        type: "radio",
        question: "Which program interests you?",
        options: ["1-Year PG Certificate", "2-Year PG Diploma", "Certificate", "Diploma", "Bachelor/Master", "Need Guidance"]
      },
      {
        id: "ielts_status",
        type: "radio",
        question: "What is your IELTS status?",
        options: ["Have 6.0+", "Taking Soon", "Not Started", "Need Help"]
      }
    ],
    financialTooltip: {
      loanOption: "💰 Study Loan Assistance: Up to 75% tuition, repayable in 4–7 years at 11% APR",
      costs: "Tuition CAD 17,000-22,500/year + Living CAD 20,000-22,500/year",
      workPermit: "Eligible for part-time work and post-graduate work permit",
      consulting: "PRO Package: LKR 1,190,000 | Plus Package: LKR 850,000 | DIY: LKR 400,000",
      entryRequirements: "A/L 3 Passes | Bachelor's | IELTS 6.0 | Show Money: LKR 5M minimum"
    }
  },
  australia: {
    name: "Australia",
    code: "australia",
    flag: "🇦🇺",
    services: ["Bachelor's", "Master's", "Top-up Degree"],
    questions: [
      {
        id: "program_interest",
        type: "radio",
        question: "Which program interests you?",
        options: ["Bachelor's Degree", "Master's Degree", "Graduate Diploma", "Vocational Education", "Need Guidance"]
      },
      {
        id: "ielts_status",
        type: "radio",
        question: "What is your IELTS status?",
        options: ["Have 6.0+", "Taking Soon", "Not Started", "Need Help"]
      }
    ],
    financialTooltip: {
      costs: "Tuition AUD 20,000-45,000/year, Living AUD 21,041/year",
      workRights: "Part-time work 40 hours per fortnight",
      postStudy: "Post-study work rights 2-4 years depending on degree",
      healthCover: "OSHC health insurance mandatory AUD 500-700/year",
      consulting: "PRO Package: LKR 1,190,000 | Plus Package: LKR 850,000 | DIY: LKR 400,000",
      entryRequirements: "A/L 3 Passes | Bachelor's | IELTS 6.0 | Show Money: LKR 5M minimum"
    }
  },
  uk: {
    name: "United Kingdom",
    code: "uk",
    flag: "🇬🇧",
    services: ["Bachelor's", "Master's", "Top-up Degree"],
    questions: [
      {
        id: "program_interest",
        type: "radio",
        question: "Which program interests you?",
        options: ["Bachelor's Degree", "Master's Degree", "PhD", "Foundation Course", "Need Guidance"]
      },
      {
        id: "ielts_status",
        type: "radio",
        question: "What is your IELTS status?",
        options: ["Have 6.0+", "Taking Soon", "Not Started", "Need Help"]
      }
    ],
    financialTooltip: {
      costs: "Tuition £10,000-20,000/year (Bachelor) / £11,000-22,000 (Master)",
      living: "Living £9,000-12,000 outside London (£12,000-15,000 in London)",
      workRights: "Part-time work up to 20 hours/week plus 2-year Graduate Route",
      healthSurcharge: "Immigration Health Surcharge £470/year",
      consulting: "PRO Package: LKR 1,190,000 | Plus Package: LKR 850,000 | DIY: LKR 400,000",
      entryRequirements: "A/L 3 Passes | Bachelor's | IELTS 6.0 | Show Money: LKR 5M minimum"
    }
  },
  newzealand: {
    name: "New Zealand",
    code: "newzealand",
    flag: "🇳🇿",
    services: ["Bachelor's", "Master's", "Work Visa"],
    questions: [
      {
        id: "program_interest",
        type: "radio",
        question: "Which program interests you?",
        options: ["Bachelor's Degree", "Master's Degree", "Work Visa", "Need Guidance"]
      },
      {
        id: "ielts_status",
        type: "radio",
        question: "What is your IELTS status?",
        options: ["Have 6.0+", "Taking Soon", "Not Started", "Need Help"]
      }
    ],
    financialTooltip: {
      costs: "Contact for specific pricing and living costs",
      workRights: "Work Visa and study-to-residency migration support",
      postStudy: "Post-study work and residency pathways available",
      consulting: "PRO Package: LKR 1,190,000 | Plus Package: LKR 850,000 | DIY: LKR 400,000",
      entryRequirements: "A/L 3 Passes | Bachelor's | IELTS 6.0 | Show Money: LKR 5M minimum"
    }
  },
  notSure: {
    name: "Not Sure",
    code: "notSure",
    flag: "🤔",
    services: ["General Guidance", "Career Assessment", "Country Comparison"],
    questions: [
      {
        id: "work_experience",
        type: "radio",
        question: "What is your work experience level?",
        options: ["Fresh Graduate", "1-2 Years", "3-5 Years", "5+ Years"]
      },
      {
        id: "field_of_study",
        type: "radio",
        question: "What field are you interested in studying?",
        options: ["Business", "Technology/IT", "Engineering", "Healthcare", "Arts/Humanities", "Need Guidance"]
      },
      {
        id: "budget_range",
        type: "radio",
        question: "What's your approximate budget per year?",
        options: ["Under $10,000", "$10,000-$20,000", "$20,000-$30,000", "Over $30,000"]
      }
    ],
    financialTooltip: {
      guidance: "We'll help you compare options based on your budget and goals",
      comparison: "Free consultation to find your best fit",
      support: "Personalized guidance for your unique situation",
      ravanaTrack: "Flight Plan™ Alliance - Apply to 5 countries with one profile",
      packages: "DIY: LKR 400K | Plus: LKR 850K | PRO: LKR 1,190K"
    }
  }
};

// Helper function to get questions for a country
export const getQuestionsForCountry = (countryCode) => {
  const country = countryData[countryCode];
  return country ? country.questions : [];
};

// Helper function to get financial tooltip for a country
export const getFinancialTooltip = (countryCode) => {
  const country = countryData[countryCode];
  return country ? country.financialTooltip : null;
};

// Helper function to get country list for selection
export const getCountryList = () => {
  return Object.keys(countryData).map(key => ({
    code: key,
    name: countryData[key].name,
    flag: countryData[key].flag,
    services: countryData[key].services
  }));
};